export default __webpack_public_path__ + "static/media/136.43365cb2.png";